import { ALL_CALL_LOGS } from "../../constant/ActionType";

export default function AllCallLogsReducer(
    state = {
        allcallogs: [],
        statusCode: null,
    },
    action
) {
    switch (action.type) {
        case ALL_CALL_LOGS:
            return {
                ...state,
                allcallogs: action.data,
                statusCode: action.status,
            };

        default:
    }

    return state;
}
